import { subYears } from "date-fns";

interface DateRangeConfig {
  start: Date;
  end: Date;
}

/**
 * Calculate the previous year date range for comparison
 * @param dateRange - The current date range
 * @returns The equivalent date range from the previous year
 */
export const getPreviousYearRange = (
  dateRange: DateRangeConfig,
): DateRangeConfig => {
  return {
    start: subYears(dateRange.start, 1),
    end: subYears(dateRange.end, 1),
  };
};

/**
 * Adjust previous year data dates to align with current year for chart display
 * @param data - Data from previous year
 * @returns Data with dates adjusted to current year
 */
export const alignPreviousYearDates = <T extends { date: Date }>(
  data: T[],
): T[] => {
  return data.map((point) => ({
    ...point,
    date: new Date(
      point.date.getFullYear() + 1,
      point.date.getMonth(),
      point.date.getDate(),
    ),
  }));
};
